import { render } from "./PlayAlongsListItem.vue?vue&type=template&id=01671f5f"
import script from "./PlayAlongsListItem.vue?vue&type=script&lang=js"
export * from "./PlayAlongsListItem.vue?vue&type=script&lang=js"

import "./PlayAlongsListItem.vue?vue&type=style&index=0&id=01671f5f&lang=css"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__